import { Helmet } from "react-helmet-async";

// Per-page SEO. Canonical/OG URLs derive from the live origin so they auto-adapt
// when a production domain is connected (update sitemap.xml / robots.txt separately).
export function Seo({ title, description, path = "/", image = "/og-image.jpg", jsonLd }) {
  const origin =
    typeof window !== "undefined" && window.location ? window.location.origin : "";
  const url = origin + path;
  const img = image.startsWith("http") ? image : origin + image;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="AI Song Prompt Studio" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
